import { Moment } from 'moment-timezone';
import { DaysDashboardPeriods, ReceivableIntervalByPeriod } from './constants';
import { nowMoment } from './date';

export const shortReceivableRanges: Array<[Moment, Moment]> = [
	[nowMoment().subtract(14, 'days'), nowMoment()],                      // 0–14
	[nowMoment().subtract(29, 'days'), nowMoment().subtract(15, 'days')], // 15–29
	[nowMoment().subtract(44, 'days'), nowMoment().subtract(30, 'days')], // 30–44
	[nowMoment().subtract(59, 'days'), nowMoment().subtract(45, 'days')], // 45–59
];

export const longReceivableRanges: Array<[Moment, Moment]> = [
	[nowMoment().subtract(29, 'days'), nowMoment()],                        // 0–29
	[nowMoment().subtract(59, 'days'), nowMoment().subtract(30, 'days')],   // 30–59
	[nowMoment().subtract(89, 'days'), nowMoment().subtract(60, 'days')],   // 60–89
	[nowMoment().subtract(119, 'days'), nowMoment().subtract(90, 'days')],  // 90–119
];

export const getReceivableLabel = (i: number, period: DaysDashboardPeriods) => {
	const interval = ReceivableIntervalByPeriod[period];
	const from = i * interval;
	const to = (i + 1) * interval - 1;

	return `${from} - ${to} days`;
};